module.exports = __webpack_public_path__ + "img/knoflooksaus-met-ovenaardappelen.eb017b78.jpeg";